import React, { PropTypes } from 'react';
import $ from 'jquery';
import ComponentRegistry from "../../Common/ComponentRegistry";

export default class MatrixController extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore("ProductCompareStore");
        this.store.listen(state => this.setState(state));
        this.state = this.store.state;
    }

    purchase (product) {
        $.ajax({
            url: this.props.purchaseUrl,
            method: "POST",
            data: {productId: product.id, quantity: product.minimumPurchaseAmount},
            success: ({ basket }) => {
                if (typeof basket !== "undefined") {
                    ComponentRegistry.getStore("BasketStore").load(basket);
                }
            },
            dataType: 'json'
        });
    }

    render() {
        const MatrixView = ComponentRegistry.get("ProductCompareViewsMatrixView");
        const properties = this.state.products
            .map(product => Object.keys(product.properties))
            .reduce((accumulator, currentValue) =>
                accumulator.concat(currentValue.filter(value =>
                    !accumulator.some(accumulatedValue => accumulatedValue === value))), [])
            .filter((value) => !this.props.blacklist.includes(value));

        if (this.state.products.length === 0) {
            return null;
        }

        return (
            <MatrixView {...this.props} {...this.state}
                        properties={properties}
                        onRemove={product => this.store.remove(product)}
                        onPurchase={product => this.purchase(product)}
                        onDifferenceOnly={(differenceOnly) => this.setState({differenceOnly})}
            />
        );
    }
}

MatrixController.defaultProps = {
    blacklist: []
};
MatrixController.propTypes = {
    blacklist: PropTypes.arrayOf("string"),
    products: PropTypes.arrayOf(
        PropTypes.shape({
            properties: PropTypes.shape({}).isRequired
        })
    ).isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductCompare/Controllers/MatrixController.jsx